import React from "react";
import MiniCartItemRow from "./MiniCartItemRow"; // Import the row component
import type { TransformedCartItem } from "../../../../cart/types/cartApiTypes";

interface MiniCartItemsListProps {
  items: TransformedCartItem[];
  currencySymbol: string;
  onRemoveItem: (key: string) => void;
  onQuantityChange: (key: string, newQuantity: number) => void; // Add quantity change handler prop
  isProcessing: boolean; // Renamed from isRemoving to reflect both update/remove
}

const MiniCartItemsList: React.FC<MiniCartItemsListProps> = ({
  items,
  currencySymbol,
  onRemoveItem,
  onQuantityChange, // Receive handler
  isProcessing, // Receive combined state
}) => {
  return (
    <div className="mini-cart-items-list">
      {/* No header row needed for mini-cart */}
      {items.map((item) => (
        <MiniCartItemRow
          key={item.key}
          item={item}
          currencySymbol={currencySymbol}
          onRemoveItem={onRemoveItem}
          onQuantityChange={onQuantityChange} // Pass handler down
          isProcessing={isProcessing} // Pass combined state down
        />
      ))}
    </div>
  );
};

export default MiniCartItemsList;
